import { useState, useEffect, useCallback } from 'react'

import { deleteSalesFunnel } from '@user/store/salesFunnel/api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { unwrapResult } from '@reduxjs/toolkit'
import { toast } from '@sales-center/components'

export const useDeleteSalesFunnel = () => {
  const dispatch = useAppDispatch()

  const [id, setId] = useState<string>()
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const executeDelete = useCallback(
    (newId: string) => {
      if (status != 'pending') setId(newId)
    },
    [status],
  )

  useEffect(() => {
    let mounted = true

    if (id) {
      const execute = async () => {
        try {
          const result = await dispatch(deleteSalesFunnel(id))

          if (mounted) {
            if (deleteSalesFunnel.fulfilled.match(result)) {
              setStatus('success')
            } else {
              unwrapResult(result)
              setStatus('fail')
            }
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
            if (error.Message) {
              toast.error(error.Message)
            } else {
              toast.error('Unexpected Error')
            }
          }
        } finally {
          setId(undefined)
        }
      }
      execute()
    }

    return () => {
      mounted = false
    }
  }, [dispatch, id])

  return executeDelete
}
